export const PUSH_NOTIFICATION_MERGE_TAGS = {
  recipientName: "{{user.name}}",
  sessionName: "{{session.title}}",
  sessionLocation: "{{session.location}}",
  eventName: "{{event.name}}",
} as const;

export type NotificationMergeTagValues = {
  recipientName?: string | null;
  sessionName?: string | null;
  sessionLocation?: string | null;
  eventName?: string | null;
};

const pushNotificationMergeTagPattern =
  /\{\{(?:user\.name|session\.title|session\.location|event\.name)\}\}/g;

export function resolvePushNotificationMergeTags(
  content: { title: string; body: string },
  values: NotificationMergeTagValues
) {
  const replacements: Record<string, string> = {
    [PUSH_NOTIFICATION_MERGE_TAGS.recipientName]: values.recipientName ?? "",
    [PUSH_NOTIFICATION_MERGE_TAGS.sessionName]: values.sessionName ?? "",
    [PUSH_NOTIFICATION_MERGE_TAGS.sessionLocation]:
      values.sessionLocation ?? "",
    [PUSH_NOTIFICATION_MERGE_TAGS.eventName]: values.eventName ?? "",
  };
  const resolve = (value: string) =>
    value.replace(pushNotificationMergeTagPattern, (tag) => replacements[tag]);

  return { title: resolve(content.title), body: resolve(content.body) };
}
